// extracted by mini-css-extract-plugin
module.exports = {"tabHost":"tabHost--1TcuT"};